module.exports = __webpack_public_path__ + "static/media/logo.78773518.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Header/logo.svg
// module id = 172
// module chunks = 0